"use client";

import * as React from "react";

import Multimedia from "@stadium/shared/src/components/shared/multimedia";
import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

import { CompanyLogo } from "@stadium/shared/src/components/plasmic/LS03";

import styles from "./main.module.scss";

interface ResponsiveLogoGridProps {
  companyLogos: CompanyLogo[];
}

export default function ResponsiveLogoGrid({ companyLogos }: Readonly<ResponsiveLogoGridProps>) {
  const { isMobileDevice, isTabletDevice } = React.useContext(CurrentDeviceContext);

  const getDeviceLogo = (logo: CompanyLogo) => {
    if (isMobileDevice) return logo.logoMobile;
    if (isTabletDevice) return logo.logoTablet;
    return logo.logoDesktop;
  };

  const visibleLogos = companyLogos
    .map((logo, index) => ({ src: getDeviceLogo(logo), alt: logo.alt, index }))
    .filter((logo) => logo.src);

  return (
    <>
      {visibleLogos.map((logo) => (
        <div className={styles.logoBox} key={`logo-item-${logo.index + 1}`}>
          <Multimedia type="image" src={logo.src} alt={logo.alt} className={styles.logoImages} />
        </div>
      ))}
    </>
  );
}
